import React from "react";
import { HiOutlinePencilSquare } from "react-icons/hi2";
import CreateAttributeModal from "../../../../../components/elements/modals/CreateAttributeModal";
import EditAttributeModal from "../../../../../components/elements/modals/EditAttributeModal";
import SkeletonTable from "../../../../../components/loader/TableSkeletonLoader";
import useSelectAttributeLogic from "../../../../../hooks/variants/useSelectAttributeLogic";

const SelectAttributes = () => {
  const {
    // Data
    rows,
    selectedAttributes,
    selectedIds,
    headerCheckboxRef,

    // Computed values
    allChecked,
    isIndeterminate,
    isAttributeListLoading,

    // Modal states
    isCreateModalOpen,
    isEditModalOpen,
    editData,

    // Actions
    toggleAll,
    toggleOne,
    isAttributeSelected,
    logSelectedAttributes,
    handleEdit,
    handleCreateNewAttribute,
    handleCloseCreateModal,
    handleCloseEditModal,
  } = useSelectAttributeLogic();

  return (
    <div className="bg-white border border-neutral-200 rounded-lg shadow-sm p-4">
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-2xl font-semibold text-gray-900">
          Step 1 : Select Attributes
        </h2>
        <div className="flex gap-2">
          {/* {selectedAttributes.length > 0 && (
            <button
              className="px-3 py-2 rounded-md bg-green-600 text-white text-sm hover:bg-green-700 active:scale-[0.99] transition"
              onClick={logSelectedAttributes}
            >
              Debug: Log Selected ({selectedAttributes.length})
            </button>
          )} */}
          <button
            className="px-4 py-2 rounded-md bg-blue-600 text-white text-sm hover:bg-blue-700 active:scale-[0.99] transition"
            onClick={handleCreateNewAttribute}
          >
            Create New Attribute
          </button>
        </div>
      </div>

      <div className="">
        <div className="text-sm text-gray-600">
          {isAttributeListLoading ? (
            <SkeletonTable
              rows={8}
              cols={["checkbox", 40, 200, 200, 100, 100, 100, 120, 120]}
              showHeader={true}
              headerLabels={[
                <div className="flex items-center gap-2" key="h0">
                  <div className="h-4 w-4 rounded bg-gray-200 animate-pulse" />
                  <span>Select All</span>
                </div>,
                "#",
                "Attribute Name",
                "Attribute Unit",
                "Required",
                "System",
                "Visible",
                "Scope",
                "Action",
              ]}
              className=""
              tableClassName=""
              rowClassName="hover:bg-gray-50/40"
              cellClassName=""
              pulse={true}
            />
          ) : rows?.length <= 0 && !isAttributeListLoading ? (
            <span>No attributes found</span>
          ) : (
            <div className="overflow-x-auto">
              <table className="w-full text-sm border-collapse">
                <thead>
                  <tr className="bg-gray-50 text-gray-600 uppercase text-xs">
                    <th className="px-4 py-3 font-semibold">
                      <div className="flex items-center gap-2">
                        <input
                          ref={headerCheckboxRef}
                          type="checkbox"
                          checked={allChecked}
                          onChange={toggleAll}
                          className="h-4 w-4 rounded border-gray-300 text-blue-600 focus:ring-blue-500"
                        />
                        <span>Select All</span>
                      </div>
                    </th>
                    <th className="px-4 py-3 text-left font-semibold">#</th>
                    <th className="px-4 py-3 text-left font-semibold">
                      Attribute Name
                    </th>
                    <th className="px-4 py-3 text-left font-semibold">
                      Attribute Unit
                    </th>
                    {/* <th className="px-4 py-3 text-left font-semibold">
                      Required
                    </th>
                    <th className="px-4 py-3 text-left font-semibold">
                      System
                    </th>
                    <th className="px-4 py-3 text-left font-semibold">
                      Visible
                    </th>
                    <th className="px-4 py-3 text-left font-semibold">Scope</th>
                    <th className="px-4 py-3 text-left font-semibold">
                      Action
                    </th> */}
                  </tr>
                </thead>

                <tbody>
                  {rows.map((r) => (
                    <tr
                      key={r.attribute_id}
                      className="border-t hover:bg-gray-50"
                    >
                      <td className="px-4 py-3">
                        <input
                          type="checkbox"
                          checked={isAttributeSelected(r.attribute_id)}
                          onChange={() => toggleOne(r)}
                          className="h-4 w-4 rounded border-gray-300 text-blue-600 focus:ring-blue-500"
                        />
                      </td>
                      <td className="px-4 py-3 text-gray-700">
                        {r.attribute_id}
                      </td>
                      <td className="px-4 py-3 text-gray-900">
                        {r.attribute_name}
                      </td>
                      <td className="px-4 py-3 text-gray-900">
                        {r.unit || "------"}
                      </td>
                      {/* <td className="px-4 py-3">Yes</td>
                      <td className="px-4 py-3">Yes</td>
                      <td className="px-4 py-3">Yes</td>
                      <td className="px-4 py-3 text-gray-800">Global</td> */}
                      <td className="px-4 py-3">
                        <button
                          onClick={() => handleEdit(r)}
                          className="p-2 rounded hover:bg-gray-100 text-gray-600 hover:text-gray-900"
                          aria-label={`Edit ${r.attribute_name}`}
                          title="Edit"
                        >
                          <HiOutlinePencilSquare size={18} />
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>

      {/* Create New Attribute Modal */}
      <CreateAttributeModal
        isOpen={isCreateModalOpen}
        onClose={handleCloseCreateModal}
      />

      {/* Edit Attribute Modal */}
      {isEditModalOpen && (
        <EditAttributeModal
          isOpen={isEditModalOpen}
          onClose={handleCloseEditModal}
          editData={editData}
        />
      )}
    </div>
  );
};

export default SelectAttributes;
